export default __webpack_public_path__ + "static/media/san-rafael.885ae9dd.jpg";